import { render, staticRenderFns } from "./CheckSolidIcon.vue?vue&type=template&id=61049812&"
import script from "./CheckSolidIcon.vue?vue&type=script&lang=js&"
export * from "./CheckSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports